import React from 'react';
import { Link } from "react-router-dom";
import TagResult from "../common/TagResult";

const PointsCell = (props: {tagResult: TagResult, userName: string }) => {

    let tagResult = props.tagResult;

    let className;
    if (isMax(tagResult)) {
        className = 'text-success';
    } else if (aboveThreshold(tagResult)) {
        className = 'text-warning';
    } else {
        className = 'text-danger';
    }

    let points =  tagResult.points ?? ''

    let link = '/output-log/' + props.userName + '/' + tagResult.tag;

    return <td>
        <span className={ className }>{points}&nbsp;</span>

        { isOutputLinkVisible(tagResult)
            ? <span>(<Link className="parent-color" to={link}>vead</Link>)</span>
            : ''
        }
    </td>;
};

function aboveThreshold(row: TagResult): boolean {
    if (row.points === undefined) {
        return false;
    }

    return row.points >= row.threshold;
}

function isMax(row: TagResult): boolean {
    if (row.points === undefined) {
        return false;
    }

    return row.points >= row.maxPoints;
}

function isOutputLinkVisible(row: TagResult): boolean {
    if (row.points === undefined) {
        return false;
    }

    return !!row.output && row.points < row.maxPoints;
}

export default PointsCell;
